<template>
  <div>
    <el-input :value="value" readonly :size="size" :placeholder="placeholder">
      <el-button
        :disabled="disabled"
        slot="append"
        icon="el-icon-finished"
        @click="() => (dialogVisible = true)"
      ></el-button>
    </el-input>
    <ChoicePackageDialog
      :value="packValue"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      @change="packageConfirm"
    />
  </div>
</template>
<script>
import ChoicePackageDialog from './dialog.vue'
export default {
  components: { ChoicePackageDialog },
  props: {
    value: { type: String, default: '' },
    packValue: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    size: { type: String, default: 'medium' },
    packageType: { type: String, default: '' },
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  computed: {
    dialogTitle() {
      const titles = {
        small: this.$l('dialog_title_package_small_edit') || '小包装信息维护',
        inner: this.$l('dialog_title_package_inner_edit') || '内包装信息维护',
        out: this.$l('dialog_title_package_out_edit') || '外包装信息维护',
      }
      return titles[this.packageType]
    },
  },
  methods: {
    packageConfirm(data) {
      let strs = ''
      let packValue = []

      if (data) {
        packValue = data.map((i) => {
          return { ...i, packageType: `${this.packageType}Package` }
        })
        strs = data.map((i) => `(${i.displayNameEn})*${i.qty}`).join('，')
      }

      this.$emit('update:packValue', packValue)
      this.$emit('update:value', strs)
      this.$emit('input', strs)
    },
  },
}
</script>
